/**
 * Headline markets shown in the desktop Market Analysis header (issue #413).
 *
 * ONE list, imported cross-tree by the worker route (`/fear-greed/markets`, which
 * fetches exactly these Yahoo symbols) and by the header badges (which label them),
 * so a symbol can never be fetched without a label or labelled without being fetched.
 *
 * `label` is the badge text (kept short, the header is tight); `name` is the plain
 * full name for the hover.
 */
export const HEADLINE_MARKETS = [
  { symbol: '^GSPC', label: 'S&P', name: 'S&P 500' },
  { symbol: '^IXIC', label: 'Nasdaq', name: 'Nasdaq Composite' },
  { symbol: 'BTC-USD', label: 'BTC', name: 'Bitcoin' },
  { symbol: 'GC=F', label: 'Gold', name: 'Gold futures' },
];
